import React from 'react';
import PropTypes from 'prop-types';
import { I18n, I18nContext, copy } from '@deporvillage/utils-library-component';

import styles from './Share.module.scss';

const Share = ({ link, onClick }) => {

    const { translate } = React.useContext(I18nContext);
    const [message, setMessage] = React.useState(null);
    const url = link.replace(/^(https?:)?\/\//, 'https://');

    const handleOnClick = () => onClick && onClick();

    const copyToClipboard = () => {
        const success = copy(url);
        setMessage(success);
        /* istanbul ignore next */
        /* eslint-disable-next-line no-undef */
        setTimeout(() => setMessage(false), 3000);
        handleOnClick();
    };

    return (
        <div className={ styles['share-component'] }>
            <div className={ 'share-buttons' }>

                <a className={`${ styles['btn-share'] } ${ styles['btn-share-whats'] }`}
                   rel='nofollow'
                   onClick={ handleOnClick }
                   href={ `whatsapp://send?text=${ translate('generic.sharing.recommend_product') } ${ url }#native-browser` }
                   target='_top'
                >
                    <span className='icon icon-whatsapp'/>
                </a>

                <a className={`${ styles['btn-share'] } ${ styles['btn-share-fb'] }`}
                   rel='nofollow noopener noreferrer'
                   onClick={ handleOnClick }
                   href={ `https://www.facebook.com/dialog/feed?app_id=300247916763187&link=${ url }` }
                   target='_blank'
                >
                    <span className='icon icon-facebook-f'/>
                </a>

                <button className={`${ styles['btn-share'] } ${ styles['btn-share-link'] }`} onClick={ copyToClipboard }>
                    <span className='icon icon-link'/>
                </button>

                <a className={`${ styles['btn-share'] } ${ styles['btn-share-email'] }`}
                   rel='nofollow'
                   onClick={ handleOnClick }
                   href={ `mailto:?subject=${ translate('generic.sharing.recommend_product') }&body=${ translate('generic.sharing.recommend_product') } ${ url }` }
                   target='_parent'
                >
                    <span className='icon icon-markunread'/>
                </a>

            </div>

            { message ? <div className={ styles['product-share-copy-success'] }>
                <I18n>generic.sharing.copy_link_confirmation</I18n></div> : null }

        </div>
    );
};

Share.propTypes = {
    link: PropTypes.string,
    onClick: PropTypes.func,
};

export default Share;
